<template>
  <instructions-component
    class="pointer-events-auto midder"
    :header="$t('instructions')"
    :button-text="$t('continue')"
    :cards="getInstructions"
    show-button
    @button-click="closeInstructions"
  />
</template>

<script lang="ts">
import { Instructions } from '@powerplay/core-minigames-ui'
import { defineComponent } from 'vue'
import {
  CorePhases,
  corePhasesManager,
  modes,
  tutorialManager
} from '@powerplay/core-minigames'
import { pathAssets } from '@/globals/globalvariables'
import { blurState } from '@/stores'

export default defineComponent({
  name: 'InstructionComponent',
  components: {
    InstructionsComponent: Instructions
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close-instructions'],
  computed: {
    getInstructions(): {imgSrc: string, header: string, text: string[]}[] {

      blurState().isActive = true

      if (modes.isTrainingMode()) {

        return [
          {
            imgSrc: `${pathAssets}/ui/instructions/training-1-v2.png`,
            header: this.$t('instructionsDisciplineTraining7Cell1Title'),
            text: [this.$t('instructionsDisciplineTraining7Cell1Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-2-v2.png`,
            header: this.$t('instructionsDisciplineTraining7Cell2Title'),
            text: [this.$t('instructionsDisciplineTraining7Cell2Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-3-v2.png`,
            header: this.$t('instructionsDisciplineTraining7Cell3Title'),
            text: [this.$t('instructionsDisciplineTraining7Cell3Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-4-v2.png`,
            header: this.$t('instructionsDisciplineTraining7Cell4Title'),
            text: [this.$t('instructionsDisciplineTraining7Cell4Text1')]
          }
        ]

      }

      return [
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-1-v3.png`,
          header: this.$t('instructionsDiscipline7Cell1Title'),
          text: [this.$t('instructionsDiscipline7Cell1Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-2-v2.png`,
          header: this.$t('instructionsDiscipline7Cell2Title'),
          text: [
            this.$t('instructionsDiscipline7Cell2Text1'),
            this.$t('instructionsDiscipline7Cell2Text2')
          ]
        }
      ]

    }
  },
  methods: {
    closeInstructions(): void {

      // pokial mame prvotne instrukcie, tak ich zavrieme
      if (corePhasesManager.isActivePhaseByType(CorePhases.instructions)) {

        corePhasesManager.getActualPhase()?.finishPhase()

      }
      this.$emit('close-instructions')
      tutorialManager.blockInputsManually()

    }
  }

})
</script>

<style lang="less" scoped>
</style>
